import { ROOT } from 'constants/routes';

import React from 'react';


import Container from '@skippay/core/components/Container';
import Link from '@skippay/core/components/Link';
import Logo from '@skippay/core/components/Logo';
import { useIntl } from '@skippay/core/i18n/intl';
import { be, bm } from '@skippay/core/utils/classUtils';

import PublicNavbar from '../PublicNavbar';
import './index.sass';

const MODULE_NAME = 'PublicHeader';

interface Props {
	headerBottomSection?: JSX.Element;
}

function PublicHeader(props: Props): JSX.Element {
	const { headerBottomSection } = props;
	const intl = useIntl();

	return (
		<div className={bm(MODULE_NAME, false, 'hidden-print')}>
			<div className={be(MODULE_NAME, 'mainNavbar')}>
				<Container xl>
					<div className={be(MODULE_NAME, 'content')}>
						<div className={be(MODULE_NAME, 'logo')}>
							<Link
								testId="homepage"
								analyticsId="homepage"
								to={ROOT}
								aria-label={intl.formatMessage({
									id: 'PublicHeader.logo',
									defaultMessage: 'Skip Pay',
								})}
							>
								<Logo lg />
							</Link>
						</div>

						<div className={be(MODULE_NAME, 'navbar')}>
							<PublicNavbar />
						</div>
					</div>
					{headerBottomSection && (
						<div className={be(MODULE_NAME, 'bottomSection')}>{headerBottomSection}</div>
					)}
				</Container>
			</div>
		</div>
	);
}

export default PublicHeader;
